import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedWorkoutMovementListList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseWorkoutMovements {
  ordering?: string;
  search?: string;
  source?: string | null;
  limit?: string;
}

function useWorkoutMovements({
  ordering,
  search,
  source,
  limit = '20',
}: IUseWorkoutMovements): UseInfiniteQueryResult<AxiosResponse<PaginatedWorkoutMovementListList>> {
  const fetchWorkoutMovements = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedWorkoutMovementListList>> => {
      const params = { ...pageParam };
      params.movement_type = 'movement';
      if (ordering) {
        params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
      }
      if (search) {
        params.search = search;
      }
      if (source) {
        params.source = source;
      }
      return client.get(`workout-movements/?${encodeUrlParams(params)}`);
    },
    [limit, ordering, search, source],
  );

  return useInfiniteQuery(['workoutMovements', ordering, search, source], fetchWorkoutMovements, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useWorkoutMovements;
